import { render, staticRenderFns } from "./DocumentsSubmitted.vue?vue&type=template&id=24578b2c&"
import script from "./DocumentsSubmitted.vue?vue&type=script&lang=js&"
export * from "./DocumentsSubmitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports